

export const getVehicles = (state) => state.vehicles_search.vehicles;
export const getLoading = (state) => state.vehicles_search.isFetching;
export const getError = (state) => state.vehicles_search.error;